var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResultsPotentiallyPositiveStrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 130,
    viewBox: "0 0 102 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52222 14.7957H39.1645",
    stroke: "#007580",
    strokeWidth: 4.64976,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4509 118.346H54.1836",
    stroke: "#007580",
    strokeWidth: 4.64976,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6604 73.2893H52.6026",
    stroke: "#007580",
    strokeWidth: 4.64976,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94141 55.8997H43.9074",
    stroke: "#007580",
    strokeWidth: 4.64976,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1662 3.52007C11.7072 4.26574 12.352 6.11952 11.6063 7.66059L11.0629 8.78371C9.48994 12.0345 8.05271 19.8256 13.7807 25.5536C18.1917 29.9646 22.721 33.1205 27.31 35.9408C28.8703 36.8997 30.5161 37.863 32.188 38.8416C35.2316 40.623 38.3614 42.4548 41.2171 44.402C50.9003 51.0041 59.32 59.6797 59.32 73.684C59.32 77.723 57.7905 81.666 55.684 85.2111C53.5562 88.7924 50.6588 92.2715 47.4868 95.4696C41.1504 101.858 33.3148 107.527 27.0783 111.061C23.5251 113.074 20.1738 116.207 17.542 119.213C16.2445 120.696 15.1692 122.093 14.3787 123.219C13.9834 123.783 13.6707 124.262 13.4431 124.635C13.3294 124.822 13.2439 124.971 13.1833 125.082C13.1263 125.187 13.1053 125.233 13.1068 125.23L12.6085 126.369C11.9222 127.937 10.0945 128.652 8.52602 127.966L6.23987 126.966C4.67142 126.28 3.95623 124.452 4.64246 122.883L5.14257 121.74C5.87466 120.067 8.10982 116.788 10.9992 113.487C13.9712 110.091 18.0635 106.175 22.7915 103.496C28.412 100.311 35.5952 95.1114 41.3134 89.3464C44.1685 86.4678 46.5574 83.5491 48.2089 80.7696C49.8819 77.954 50.6249 75.5733 50.6249 73.684C50.6249 63.9744 45.1082 57.5788 36.3189 51.5861C33.6676 49.7784 31.0413 48.2449 28.2141 46.5941C26.4872 45.5858 24.6855 44.5337 22.7573 43.3487C17.8608 40.3394 12.7068 36.7764 7.63232 31.7019C-1.81658 22.253 0.856589 9.91379 3.23594 4.99648L3.77939 3.87335C4.52507 2.33229 6.37884 1.6875 7.91991 2.43317L10.1662 3.52007Z",
    fill: "#284993"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0128 5.21761C57.0601 6.57189 56.8113 8.51877 55.457 9.56608L54.47 10.3293C44.6775 17.9022 23.5586 34.1116 18.6512 37.3832C16.4322 38.8625 11.7522 43.6468 10.081 50.2899C8.52006 56.4945 9.39849 65.0422 19.3138 74.9575C26.5254 82.169 33.0126 87.1081 38.838 91.5432C41.6998 93.7221 44.402 95.7793 46.9518 97.9247C50.6792 101.061 54.0135 104.373 56.387 108.389C58.8125 112.494 60.1102 117.119 60.1102 122.693V123.94C60.1102 125.652 58.7224 127.04 57.0104 127.04H54.515C52.803 127.04 51.4152 125.652 51.4152 123.94V122.693C51.4152 118.583 50.4897 115.501 48.9012 112.813C47.2606 110.036 44.7899 107.469 41.3538 104.578C39.3255 102.871 36.9149 101.032 34.2292 98.9819C28.193 94.3749 20.7666 88.707 13.1654 81.1058C1.34303 69.2834 -0.742775 57.6744 1.64863 48.1686C3.9297 39.1013 10.1185 32.6215 13.828 30.1485C18.4062 27.0964 39.1818 11.1605 49.1508 3.45109L50.1378 2.68782C51.4921 1.64051 53.4389 1.88936 54.4863 3.24363L56.0128 5.21761Z",
    fill: "#FF7F50"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.178 56.7766C101.178 78.2631 83.7596 95.6813 62.2731 95.6813C40.7867 95.6813 23.3684 78.2631 23.3684 56.7766C23.3684 35.2901 40.7867 17.8718 62.2731 17.8718C83.7596 17.8718 101.178 35.2901 101.178 56.7766Z",
    fill: "#60C2A5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2731 92.4439C81.9717 92.4439 97.9405 76.4751 97.9405 56.7766C97.9405 37.078 81.9717 21.1092 62.2731 21.1092C42.5746 21.1092 26.6058 37.078 26.6058 56.7766C26.6058 76.4751 42.5746 92.4439 62.2731 92.4439ZM62.2731 95.6813C83.7596 95.6813 101.178 78.2631 101.178 56.7766C101.178 35.2901 83.7596 17.8718 62.2731 17.8718C40.7867 17.8718 23.3684 35.2901 23.3684 56.7766C23.3684 78.2631 40.7867 95.6813 62.2731 95.6813Z",
    fill: "black",
    fillOpacity: 0.05
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.331,
    cy: 56.9062,
    rx: 28.0576,
    ry: 28.0576,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsPotentiallyPositiveStrand);
export default __webpack_public_path__ + "static/media/results-potentially-positive-strand.8cd9661300f90f11fcf606ab4e932fc6.svg";
export { ForwardRef as ReactComponent };